import { render, staticRenderFns } from "./feishuAuth.vue?vue&type=template&id=67880702&"
import script from "./feishuAuth.vue?vue&type=script&lang=js&"
export * from "./feishuAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports